"use client"

import * as CheckboxPrimitive from "@radix-ui/react-checkbox"

import { twMerge } from "tailwind-merge"
import CheckIcon from "./Icons/check"
import { useEffect, useState } from "react"

type CheckboxProps = React.ComponentProps<typeof CheckboxPrimitive.Root> & {
    label?: string
}

const Checkbox = ({ label, className, checked,
    onCheckedChange, ...props }: CheckboxProps) => {
    const [isChecked, setIsChecked] = useState<CheckboxPrimitive.CheckedState>(checked ?? false);

    const handleClick = (value: CheckboxPrimitive.CheckedState) => {
        setIsChecked(value ?? false);
        onCheckedChange?.(value);
    };

    useEffect(() => {
        setIsChecked(checked ?? false);
    }, [checked]);

    return (
        <label className="w-full flex flex-row items-center gap-2 cursor-pointer">
            <CheckboxPrimitive.Root
                data-slot="checkbox"
                className={twMerge(
                    "flex size-4 items-center justify-center rounded-[4px] border-[1.5px] border-gray-200 shrink-0 relative outline-none",
                    "data-[state=checked]:bg-gray-900 data-[state=checked]:border-gray-900 data-[state=checked]:text-white",
                    "disabled:cursor-not-allowed disabled:opacity-50",
                    className
                )}
                {...props}
                onCheckedChange={handleClick}
                checked={isChecked}
            >
                <CheckboxPrimitive.Indicator
                    data-slot="checkbox-indicator"
                    className="[&>svg]:size-[6px] grid place-content-center text-current"
                >
                    <CheckIcon />
                </CheckboxPrimitive.Indicator>
            </CheckboxPrimitive.Root>

            {label && (
                <p
                    onClick={() =>
                        setIsChecked(prev => (prev === "indeterminate" ? true : !prev))
                    }
                    className="text-gray-900 text-sm font-medium leading-5 font-sans select-none"
                >
                    {label}
                </p>
            )}
        </label>
    )
}

export { Checkbox }
